import { render } from "./NoahMasterLevelsforEdu.vue?vue&type=template&id=a551ad20&scoped=true"
import script from "./NoahMasterLevelsforEdu.vue?vue&type=script&lang=js"
export * from "./NoahMasterLevelsforEdu.vue?vue&type=script&lang=js"

import "./NoahMasterLevelsforEdu.vue?vue&type=style&index=0&id=a551ad20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a551ad20"]])

export default __exports__